<template>
  <div v-if="isPC">
    <div class="candies-draw-content">
      <img class="top-image" src="./images/candies-banner.png" alt="" />
      <div class="draw-content">
        <img
          class="candies-accumulated"
          :src="require(`./images/${target}.png`)"
          alt=""
        />
        <div class="lollipop">
          當前獎池共累積
          <span>{{ activityData.ticket }}</span> 個棒棒糖， 距離開獎還有
          <span v-show="activityData.lotteryNum">{{ lollipopDisantce }}</span>
          個棒棒糖
        </div>
        <div class="candies-num">
          {{ activityData.crystalBalance }}
        </div>
        <div class="lollipop-num">
          {{ activityData.ticketBalance }}
        </div>
        <img
          class="draw-immediately"
          src="./images/buttonImmediately.png"
          :style="
            isGrayscale
              ? { filter: 'grayscale(0.75)' }
              : { filter: 'grayscale(0)' }
          "
          @click="getDraw"
        />
      </div>

      <img class="rules" src="./images/rules.png" alt="" />
      <template v-if="isFinished">
        <div class="winners">
          <img class="star" src="./images/star-star.png" />
          <div class="rank-info">
            <div class="second-info">
              <img class="second-crown" src="./images/second-crown.png" />

              <img class="second" src="./images/winners-second.jpg" />
              <div class="name">
                芽蜜✨想看電影🎬
              </div>
            </div>
            <div class="first-info">
              <img class="first-crown" src="./images/first-crown.png" />
              <img class="first" src="./images/winners-first.jpg" />
              <div class="name">
                溫扁扁
              </div>
            </div>
            <div class="third-info">
              <img class="third-crown" src="./images/third-crown.png" />

              <img class="third" src="./images/winners-third.jpg" />
              <div class="name">
                小沫⋆⸜♡⸝‍⋆
              </div>
            </div>
          </div>
          <div class="winning">
            <div class="title">中獎名單</div>
            <div class="winning-list">
              <div>用戶 <span>溫扁扁</span> 獲得 applewatch</div>
              <div>
                用戶 <span>芽蜜✨想看電影🎬</span> 獲得 5000鑽石+1500現金
              </div>
              <div>用戶 <span>小沫⋆⸜♡⸝‍⋆</span> 獲得 2000鑽石+1000現金</div>
              <div v-for="item in winnersInfo" :key="item.id">
                用戶 <span>{{ item.nickName }}</span> 獲得 1500 鑽石
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- 兌換彈窗 -->
    <el-dialog
      title="獎券兌換"
      :visible.sync="showExchangeDialog"
      center
      append-to-body
    >
      <div class="exchange-dialog">
        <div class="exchange-item">
          <span>我有</span>
          <!-- 縂水晶數 -->
          <span class="exchange-crystal-number">{{
            activityData.crystalBalance
          }}</span>
          <img src="./images/candies.png" />
        </div>
        <div class="exchange-container">
          <span class="exchange-container-item">兌換</span>

          <el-input
            v-model="ticketValue"
            :max="12000"
            :min="null"
            @input="onInput"
            class="nicee-input-box"
            :class="{ 'less-crystal-value': isLessCrystalValue }"
          >
            <template slot="prefix"
              ><span
                role="button"
                class="el-input-number__decrease"
                @click="deleteNum()"
                ><i class="el-icon-minus"></i></span
            ></template>
            <template slot="suffix"
              ><span
                role="button"
                class="el-input-number__increase"
                @click="addNum()"
                ><i class="el-icon-plus"></i></span
            ></template>
          </el-input>
          <span class="exchange-container-item">張券</span>
        </div>
        <div class="need-container">
          <div
            class="need-crystal"
            :style="{
              'background-color': isLessCrystalValue
                ? 'rgba(255, 40, 195, 0.2)'
                : 'inherit'
            }"
          >
            <span>需要</span>
            <!-- 兌換獎券需要的水晶數 -->
            <span class="need-crystal-number">{{ crystalValue }}</span>
            <span>水晶</span>
          </div>
          <div class="crystal-deficiency" v-if="isLessCrystalValue">
            水晶不足啦，快去下單吧
          </div>
        </div>
        <button class="exchange-button" @click="onExchange">兌換</button>
      </div>
    </el-dialog>
  </div>
  <min-candies v-else></min-candies>
</template>
<script>
import minCandies from './min-candies.vue';
import { mapGetters } from 'vuex';
import Login from '@/components/Login/index';
export default {
  components: {
    minCandies
  },
  data() {
    return {
      //後七名獲獎名單
      winnersInfo: [
        {
          id: 1208234,
          nickName: '車禍小瑩👻OW+'
        },
        {
          id: 3286787,
          nickName: '92'
        },
        {
          id: 620360,
          nickName: '♋️豪愛妳♍️'
        },
        {
          id: 339466,
          nickName: 'Du🌸可接ow2'
        },
        {
          id: 3700853,
          nickName: '寫下你的名字'
        },
        {
          id: 1152472,
          nickName: '企鵝小寶貝❤️'
        },
        {
          id: 1061168,
          nickName: '芳芳ㄦ💗本照（昏迷'
        }
      ],
      //兌換彈窗展示
      showExchangeDialog: false,
      // 需要兌換棒棒糖數量
      ticketValue: '',
      //糖果活動的數據
      activityData: {},
      //棒棒糖不足判斷
      isLessCrystalValue: false,
      //獎勵檔位信息
      gearsInfo: []
    };
  },
  methods: {
    //點擊立即抽獎-檢查登錄，彈窗兌換頁面
    async getDraw() {
      // 檢查登錄
      await this.checkLogin();
      if (this.activityData.ticket >= 12000) {
        this.showExchangeDialog = false;
      } else {
        console.log('點擊立即抽獎，彈窗兌換頁面');
        this.ticketValue = '';
        this.isLessCrystalValue = false;
        this.showExchangeDialog = true;
      }
    },
    // 检查登录
    checkLogin() {
      return new Promise(resolve => {
        if (!this.userInfo) {
          Login();
          return;
        } else {
          resolve();
        }
      });
    },
    //獲取活動信息
    getActivityLotteryInfo() {
      this.$http.get('/activity/getActivityLotteryInfo').then(({ data }) => {
        this.activityData = data;
        this.gearsInfo = JSON.parse(data.gearsInfo);
      });
    },
    //兌換,限制最多12000個
    onExchange() {
      if (this.activityData.crystalBalance >= this.crystalValue) {
        this.postconvertAccount();
        this.getActivityLotteryInfo();
        this.showExchangeDialog = false;
        console.log('兌換');
      } else {
        this.isLessCrystalValue = true;
      }
    },
    //關閉彈窗
    closeExchangeDialog() {
      this.getActivityLotteryInfo();
      this.showExchangeDialog = false;
    },
    //彈窗數據
    postconvertAccount() {
      this.$http
        .post('/account/convertAccount', {
          accountKind: 'Crystal',
          convertAccountKind: 'Ticket',
          convertAmount: this.ticketValue,
          userUuid: this.userInfo.uuid
        })
        .then(() => {
          this.getActivityLotteryInfo();
        });
    },
    //兌換框中不能輸入首位為0的獎券數,不能輸入字符
    onInput() {
      this.ticketValue = this.ticketValue
        .toString()
        .replace(/^(0+)|[^\d]+/g, '');
    },

    deleteNum() {
      this.ticketValue =
        this.ticketValue && this.ticketValue > 1 ? --this.ticketValue : '';
    },
    addNum() {
      this.ticketValue = this.ticketValue ? ++this.ticketValue : 1;
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'token', 'refreshToken']),
    // 活動結束，開獎
    isFinished() {
      return true
    },
    //距離開獎還需棒棒糖數量
    lollipopDisantce() {
      if (this.activityData) {
        return this.activityData.lotteryNum - this.activityData.ticket;
      }
      return 0;
    },

    //ticket達到12000個，進入抽獎頁面按鈕置灰
    isGrayscale() {
      return this.activityData && this.activityData.ticket >= 12000;
    },
    // 是否已登录状态

    //目標檔位
    target() {
      let index = 0;
      if (this.gearsInfo.length) {
        switch (this.activityData.gearsAward) {
          case 0:
            index = 0;
            break;
          case 1000:
            index = 1;
            break;
          case 3000:
            index = 2;
            break;
          case 8000:
            index = 3;
            break;
          default:
            index = 3;
            break;
        }
      }
      return this.gearsInfo[index] ? this.gearsInfo[index].node : 12000;
    },

    //根據券數自動計算水晶值
    crystalValue() {
      return this.ticketValue * 200;
    }
  },
  created() {
    this.getActivityLotteryInfo();
  }
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 600px) {
  .candies-draw-content {
    background-color: #f7ffe5;
    display: flex;
    flex-direction: column;
    align-items: center;
    .name {
      font-size: 14px;
      line-height: 14px;
      font-weight: 500;
      text-align: center;
      margin-top: 7px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 82px;
    }
    .top-image {
      width: 100%;
    }
    .draw-content {
      width: 980px;
      height: 787px;
      background: url('./images/draw.png') no-repeat center center;
      position: relative;
      .candies-accumulated {
        width: 353px;
        height: 147px;
        position: absolute;
        top: 137px;
        left: 325px;
      }
      .lollipop {
        position: absolute;
        width: 530px;
        height: 38px;
        top: 510px;
        left: 226px;
        text-align: center;
        line-height: 38px;
        > span {
          color: #735cff;
        }
      }
      .candies-num,
      .lollipop-num {
        position: absolute;
        top: 583px;
        font-size: 16px;
        font-weight: 600;
        color: #0d183b;
      }
      .candies-num {
        right: 527px;
      }
      .lollipop-num {
        right: 199px;
      }
      .draw-immediately {
        width: 380px;
        height: 72px;
        position: absolute;
        bottom: 31px;
        left: 300px;
      }
    }
    .rules {
      width: 980px;
      height: 460px;
      margin: 20px 0;
    }

    .winners {
      width: 983px;
      height: 264px;
      background: url(./images/winners.png) no-repeat center center;
      position: relative;
      display: flex;
      justify-content: space-around;
      .star {
        width: 95px;
        height: 110px;
        margin-top: 105px;
        margin-left: 48px;
      }
      .rank-info {
        width: 286px;
        height: 116px;
        position: absolute;
        left: 76px;
        top: 112px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > div {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          .first-crown {
            width: 30px;
            height: 30px;
            position: absolute;
            left: 66px;
            top: -12px;
          }
          .second-crown,
          .third-crown {
            width: 30px;
            height: 30px;
            position: absolute;
            left: 58px;
            top: -14px;
          }
          .first {
            width: 90px;
            height: 90px;
            border-radius: 50%;
          }
          .second,
          .third {
            width: 70px;
            height: 70px;
            border-radius: 50%;
          }
        }
      }
      .winning {
        // text-align: center;
        margin-top: 100px;

        .title {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 14px;
        }
        .winning-list {
          width: 350px;
          height: 91px;
          font-size: 14px;
          line-height: 21px;
          font-weight: 400;
          overflow: auto;
        }
        .winning-list::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }
}

/deep/ .el-dialog {
  background: #735cff url(./images/max-dialog.png) no-repeat center 20px;
  width: 600px;
  height: 430px;
  background-size: 560px 300px;
  border-radius: 14px;
  .el-dialog__title {
    font-size: 28px;
    font-weight: 600;
  }
  .el-dialog__headerbtn {
    margin-right: 10px;
  }
  .el-dialog__body {
    padding-top: 15px;
  }
  .el-dialog__header {
    padding-top: 40px;
  }
  .exchange-dialog {
    display: flex;
    flex-direction: column;
    align-items: center;
    .exchange-item {
      display: flex;
      line-height: 30px;
      > span {
        font-size: 20px;
        font-weight: 600;
      }
      .exchange-crystal-number {
        color: #ffa336;
        font-size: 18px;
        // line-height: 18px;
        margin: 0 8px;
      }
    }
    .exchange-container {
      width: 490px;
      height: 70px;
      border: 1px solid;
      border-radius: 70px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 24px;
      .nicee-input-box {
        &.el-input {
          width: 300px;
          .less-crystal-value {
            .el-input__inner {
              color: #f33333;
            }
          }
          .el-input__inner {
            padding: 0 60px;
            border: none;
            text-align: center;
          }
          .el-input-number__decrease,
          .el-input-number__increase {
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: inline-block;
            line-height: 37px;
          }
        }
      }
      // .less-crystal-value {
      //   .el-input__inner {
      //     color: #f33333;
      //   }
      // }
      .exchange-container-item {
        font-size: 16px;
        font-weight: 600;
      }
      .el-input-number {
        width: 200px;
        margin: 0px 30px;
      }

      .el-icon-minus,
      .el-icon-plus {
        font-weight: 600;
      }
      .el-input-number__decrease {
        background: #ccdbe0;
        color: #4f7189;
        border: 1px solid #4f7189;
      }
      .el-input-number__increase {
        background: #ffd53d;
        color: #0d183b;
        border: 1px solid #0d183b;
      }
    }
    .need-container {
      margin-top: 18px;
      text-align: center;
      font-size: 16px;
      .need-crystal {
        width: 187px;
        height: 26px;
        // background: rgba(255, 40, 195, 0.2);
        border-radius: 4px;
        line-height: 26px;
        > span {
          font-size: 16px;
          font-weight: 600;
        }
      }
      .need-crystal-number {
        display: inline-block;
        color: #fd68b5;
        font-size: 18px;
        // line-height: 18px;
        margin: 0 8px;
        overflow: hidden;
        max-width: 90px;
        white-space: nowrap;
        vertical-align: middle;
      }
      .crystal-deficiency {
        color: rgb(243, 51, 51);
        font-size: 14px;
        margin: 8px 0 0 20px;
        position: absolute;
      }
    }
    .exchange-button {
      width: 170px;
      height: 48px;
      margin-top: 86px;
      background: url(./images/max-exchange.png) no-repeat center;
      font-size: 18px;
      font-weight: 600;
    }
  }
}
</style>
